// import React from "react";
import {
  Container,
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  Link,
  Paper,
} from "@mui/material";

// Replace with your own image URL or import
const headerImage =
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1500&q=80";

const TermsAndConditions = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4, px: 2, fontSize: "0.9rem" }}>
      {/* Header with Image */}
      <Box mb={3} textAlign="center">
        <Paper
          elevation={3}
          sx={{ display: "inline-block", borderRadius: 2, overflow: "hidden" }}
        >
          {/* <img
						src={headerImage}
						alt="Courier Service"
						style={{
							width: "100%",
							height: "auto",
							maxHeight: 200,
							objectFit: "cover",
						}}
					/> */}
        </Paper>
        <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 2 }}>
          Terms & Conditions
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
          Your trusted courier partner - delivering excellence with care
        </Typography>
      </Box>

      {/* Introduction */}
      <Typography variant="body2" paragraph>
        Welcome to our courier service. Please read these Terms and Conditions
        carefully before using our service.
      </Typography>

      {/* Section 1 */}
      <Typography variant="h6" gutterBottom>
        1. Acceptance of Terms
      </Typography>
      <Typography variant="body2" paragraph>
        By accessing and using our services, you agree to comply with these
        Terms and Conditions. If you do not agree, please refrain from using our
        platform.
      </Typography>

      {/* Section 2 */}
      <Typography variant="h6" gutterBottom>
        2. Service Description
      </Typography>
      <Typography variant="body2" paragraph>
        We provide courier and delivery services for parcels of various sizes
        and types within the specified regions. Our goal is to ensure safe,
        timely, and reliable delivery.
      </Typography>

      {/* Section 3 */}
      <Typography variant="h6" gutterBottom>
        3. User Responsibilities
      </Typography>
      <List dense>
        <ListItem>
          <ListItemText primary="Provide accurate and complete information during registration and booking." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Ensure that the parcels are properly packed and labeled." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Comply with all applicable laws and regulations." />
        </ListItem>
      </List>

      {/* Section 4 */}
      <Typography variant="h6" gutterBottom>
        4. Payment and Pricing
      </Typography>
      <Typography variant="body2" paragraph>
        Our pricing is transparent and payable at the time of booking. We accept
        various payment methods including credit/debit cards, digital wallets,
        and bank transfers.
      </Typography>

      {/* Section 5 */}
      <Typography variant="h6" gutterBottom>
        5. Liability and Insurance
      </Typography>
      <Typography variant="body2" paragraph>
        We strive to handle parcels with care, but we are not liable for damages
        or loss unless caused by our negligence. Optional insurance can be
        purchased for added protection.
      </Typography>

      {/* Footer / Contact */}
      <Divider sx={{ my: 4 }} />
      <Box textAlign="center">
        <Typography variant="body2" color="textSecondary">
          For any questions, please contact us at{" "}
          <Link href="mailto:support@courierwebsite.com" underline="hover">
            support@courierwebsite.com
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsAndConditions;
